export default "__VITE_ASSET__bw35E3pM__"